import { createClient } from "@supabase/supabase-js";

const url = process.env.REACT_APP_SUPABASE_URL || "";
const key = process.env.REACT_APP_SUPABASE_ANON_KEY || "";

export const supabase = url && key ? createClient(url, key) : null;

export async function saveLead(data) {
  if (!supabase) return;
  await supabase.from("leads").insert([data]).then(({ error }) => {
    if (error) console.error("Supabase lead insert error:", error.message);
  });
}
